import { ThemeUIStyleObject } from "theme-ui";

export const contactContainerStyles: ThemeUIStyleObject = {
  mt: [6, 6, 0],
  textAlign: "center",
};

export const imageWrapStyles: ThemeUIStyleObject = {
  width: ["193px"],
  height: ["193px"],
  borderRadius: "50%",
  overflow: "hidden",
  margin: "0 auto",
  position: "relative",
  bg: "darkGreen",
  "&:after": {
    content: "''",
    position: "absolute",
    top: "50%",
    left: "50%",
    zIndex: "1",
    width: "80%",
    height: "80%",
    borderRadius: "50%",
    border: "3px solid rgba(255, 255, 255, 0.3)",
    transform: "translate(-50%, -50%)",
    transition: "border 0.3s",
  },
  "a:hover &, a:focus &": {
    "&:after": {
      borderColor: "white",
    },
  },
};

export const imageStyles: ThemeUIStyleObject = {
  height: "full",
  width: "full",
};

export const contentStyles: ThemeUIStyleObject = {
  pt: 6,
  fontSize: "paragraphMedium",
};

export const headingStyles: ThemeUIStyleObject = {
  mb: 2,
  fontSize: "paragraphMedium",
  color: "darkGreen",
};

export const titleOrDepartmentStyles: ThemeUIStyleObject = {
  mb: 3,
  fontStyle: "italic",
};

export const linkStyles: ThemeUIStyleObject = {
  mb: 1,
  "&:last-of-type": {
    mb: 0,
  },
  a: {
    textDecoration: "none",
    "&:hover, &:focus": {
      color: "darkGreen",
      textDecoration: "underline",
    },
  },
};
